var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "arrow-left_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 4.293a1 1 0 010 1.414L6.414 12l6.293 6.293a1 1 0 01-1.414 1.414l-7-7a1 1 0 010-1.414l7-7a1 1 0 011.414 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMTJDNCAxMS40NDc3IDQuNDQ3NzIgMTEgNSAxMUgxOUMxOS41NTIzIDExIDIwIDExLjQ0NzcgMjAgMTJDMjAgMTIuNTUyMyAxOS41NTIzIDEzIDE5IDEzSDVDNC40NDc3MiAxMyA0IDEyLjU1MjMgNCAxMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNzA3MSA0LjI5Mjg5QzEzLjA5NzYgNC42ODM0MiAxMy4wOTc2IDUuMzE2NTggMTIuNzA3MSA1LjcwNzExTDYuNDE0MjEgMTJMMTIuNzA3MSAxOC4yOTI5QzEzLjA5NzYgMTguNjgzNCAxMy4wOTc2IDE5LjMxNjYgMTIuNzA3MSAxOS43MDcxQzEyLjMxNjYgMjAuMDk3NiAxMS42ODM0IDIwLjA5NzYgMTEuMjkyOSAxOS43MDcxTDQuMjkyODkgMTIuNzA3MUMzLjkwMjM3IDEyLjMxNjYgMy45MDIzNyAxMS42ODM0IDQuMjkyODkgMTEuMjkyOUwxMS4yOTI5IDQuMjkyODlDMTEuNjgzNCAzLjkwMjM3IDEyLjMxNjYgMy45MDIzNyAxMi43MDcxIDQuMjkyODlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgArrowLeft as ReactComponent };